export default {"src":"/_next/static/media/cart-black-mobile.91050f8b.svg","height":40,"width":34};